<script setup lang="ts">
import { IconChevronDown } from "@tabler/icons-vue";
import {
	SelectScrollDownButton,
	type SelectScrollDownButtonProps,
	useForwardProps,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	SelectScrollDownButtonProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectScrollDownButton
		v-bind="forwardedProps"
		:class="twMerge(
			'flex cursor-default items-center justify-center py-1',
			props.class
		)"
	>
		<slot>
			<IconChevronDown class="h-4 w-4" />
		</slot>
	</SelectScrollDownButton>
</template>
